
export const buildURLQueryParams = (url, params) => {
    if (params == undefined || Object.keys(params).length == 0) {
        return url;
    }
    return url + "?" + Object.keys(params).map(key => key + "=" + params[key]).join("&");
};

export default buildURLQueryParams;
